import type { ComponentProps } from 'react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/shared/lib/utils'
import { useFormField } from '@/components/ui/form'

type TranslatedFormMessageProps = ComponentProps<'p'>

export function TranslatedFormMessage({
  className,
  ...rest
}: TranslatedFormMessageProps) {
  const { t } = useTranslation()
  const { error, formMessageId } = useFormField()
  const body = error?.message ? t(error.message as string) : null
  if (!body) {
    return null
  }
  return (
    <p
      data-slot="form-message"
      id={formMessageId}
      className={cn('text-sm text-destructive', className)}
      {...rest}
    >
      {body}
    </p>
  )
}
